import { FieldConfig } from "./types";

export const config: FieldConfig[] = [
  // Search Vehicle
  {
    name: "VehicleLicensePlate",
    type: "searchtext",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleLicensePlateVin.label"),
      isVisible: true,
      isDisabled: route === "offer",
    }),
    tooltip: "sag.calculationForm.vehicleLicensePlate.tooltip",
    section: "searchVehicle",
    position: "left",
  },
  {
    name: "OwnerId",
    type: "searchtext",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerId.label"),
      isVisible: true,
      isDisabled: route === "offer",
    }),
    tooltip: "sag.calculationForm.ownerId.tooltip",
    section: "searchVehicle",
    position: "left",
  },

  {
    name: "VehicleLicensePlate",
    type: "text",
    isRequired: false,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleLicensePlate.label"),
      isVisible: true,
      isDisabled: true,
    }),
    tooltip: "sag.calculationForm.vehicleLicensePlate.tooltip",
    section: "generalInfo",
    position: "left",
  },
  {
    name: "VehicleVin",
    type: "text",
    isRequired: false,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleVin.label"),
      isVisible: true,
      isDisabled: true,
    }),
    tooltip: "sag.calculationForm.vehicleVin.tooltip",
    section: "generalInfo",
    position: "middle",
  },
  {
    name: "OwnerId",
    type: "text",
    isRequired: false,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerId.label"),
      isVisible: true,
      isDisabled: true,
    }),
    tooltip: "sag.calculationForm.ownerId.tooltip",
    section: "generalInfo",
    position: "right",
  },

  // Company Details
  {
    name: "OwnerLastName",
    type: "text",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.companyName.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: false,
  },
  {
    name: "OwnerCity",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGCityOrDistrict",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.city.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "middle",
    isPhysicalPerson: false,
  },
  {
    name: "OwnerAddress",
    isRequired: true,
    isMultiline: true,
    rows: 4,
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.address.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "middle",
    isPhysicalPerson: false,
  },
  {
    name: "OtherDrivers",
    type: "checkbox",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.youngestDriver.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: false,
  },
  {
    name: "OtherDriverAge",
    type: "number",
    format: "integer",
    d: ({ route, t, values }) => ({
      label: t("sag.calculationForm.otherDriverAge.label"),
      isDisabled: route === "offer" || !values.OtherDrivers,
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: false,
  },
  {
    name: "OtherDriverExperience",
    type: "number",
    format: "integer",
    d: ({ route, t, values }) => ({
      label: t("sag.calculationForm.otherDriverExperience.label"),
      isDisabled: route === "offer" || !values.OtherDrivers,
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: false,
  },

  // Person Details
  {
    name: "OwnerLastName",
    type: "text",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.lastName.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "OwnerFirstName",
    type: "text",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.firstName.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "OwnerEmail",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerEmail.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "OwnerTelephone",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerTelephone.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    isRequired: true,
    name: "OwnerBirthDate",
    type: "date",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.birthDate.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "middle",
    isPhysicalPerson: true,
    maxDate: new Date(),
  },

  {
    name: "OwnerCity",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGCityOrDistrict",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.city.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "middle",
    isPhysicalPerson: true,
  },
  {
    name: "OwnerAddress",
    isRequired: true,
    isMultiline: true,
    rows: 4,
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.address.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "middle",
    isPhysicalPerson: true,
  },
  {
    name: "OwnerDrivingLicenseDate",
    isRequired: true,
    type: "date",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.drivingLicenseDate.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: true,
  },

  {
    name: "OtherDrivers",
    isRequired: true,
    type: "checkbox",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.otherDrivers.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: true,
  },
  {
    name: "OtherDriverAge",
    type: "number",
    format: "integer",
    d: ({ route, t, values }) => ({
      label: t("sag.calculationForm.otherDriverAge.label"),
      isDisabled: route === "offer" || !values.OtherDrivers,
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: true,
  },
  {
    name: "OtherDriverExperience",
    type: "number",
    format: "integer",
    d: ({ route, t, values }) => ({
      label: t("sag.calculationForm.otherDriverExperience.label"),
      isDisabled: route === "offer" || !values.OtherDrivers,
    }),
    section: "owner",
    position: "right",
    isPhysicalPerson: true,
  },

  // Vehicle Details
  {
    name: "VehicleBrand",
    type: "text",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleBrand.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "left",
  },
  {
    name: "VehicleModel",
    type: "text",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleModel.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "left",
  },
  {
    name: "VehicleClass",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGVehicleClass",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleClass.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "left",
  },
  {
    name: "VehiclePowerKw",
    type: "number",
    isRequired: true,
    format: "integer",
    borderless: false,
    suffix: "kW",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehiclePower.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "middle",
  },
  {
    name: "VehicleCubicCapacity",
    type: "number",
    format: "integer",
    isRequired: true,
    borderless: false,
    suffix: "ccm",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleCapacity.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "middle",
  },
  {
    name: "VehicleWeight",
    type: "number",
    format: "integer",
    isRequired: true,
    borderless: false,
    suffix: "kg",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.weight.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "middle",
  },
  {
    name: "VehicleMaximumGrossWeight",
    type: "number",
    isRequired: true,
    format: "integer",
    borderless: false,
    suffix: "kg",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.maximumWeight.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "middle",
  },
  {
    name: "VehicleSeats",
    type: "number",
    isRequired: false,
    format: "integer",
    miniComponent: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleSeats.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "middle",
  },

  {
    name: "VehicleManufacturedOn",
    type: "date",
    isRequired: true,
    miniComponent: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.manufacturedDate.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "right",
  },
  {
    name: "VehicleFirstRegistrationOn",
    type: "date",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.registrationDate.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "right",
  },
  {
    name: "VehicleUsage",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGVehicleUsageType",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.vehicleUsage.label"),
      isDisabled: route === "offer",
    }),
    section: "vehicle",
    position: "right",
  },
  // Contract Details
  {
    name: "PolicyStartDate",
    type: "date",
    isRequired: true,
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.policyStartDate.label"),
      isDisabled: route === "offer",
    }),
    section: "contract",
    position: "left",
  },
  {
    name: "PolicyPeriod",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGPolicyPeriod",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.policyPeriod.label"),
      isDisabled: route === "offer",
    }),
    section: "contract",
    position: "middle",
  },
  {
    name: "PaymentCount",
    format: "integer",
    type: "number",
    isRequired: true,
    miniComponent: true,

    d: ({ route, t }) => ({
      label: t("sag.calculationForm.paymentCount.label"),
      isDisabled: route === "offer",
    }),
    section: "contract",
    position: "right",
  },
  {
    name: "Compensa_MiniCASCO",
    type: "taxonomy",
    isRequired: false,
    taxonomyKey: "SAGCompensaMiniCASCO",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.compensa_MiniCASCO.label"),
      isDisabled: route === "offer",
    }),
    section: "compensa",
    position: "left",
  },

  {
    name: "Compensa_PolicyCoverageEURAndGreenCardCountries",
    type: "checkbox",
    d: ({ route, t }) => ({
      label: t(
        "sag.calculationForm.compensa_PolicyCoverageEURAndGreenCardCountries.label"
      ),
      isDisabled: route === "offer",
    }),
    section: "compensa",
    position: "middle",
  },
  {
    name: "Ergo_DiscountPercent",
    type: "number",
    borderless: false,
    suffix: "%",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ergoDiscountPercent.label"),
      isDisabled: route === "offer",
    }),
    section: "ergo",
    position: "left",
    isPhysicalPerson: true,
  },

  {
    name: "Ergo_DiscountPercent",
    type: "number",
    borderless: false,
    suffix: "%",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ergoDiscountPercent.label"),
      isDisabled: route === "offer",
    }),
    section: "ergo",
    position: "left",
    isPhysicalPerson: false,
  },

  {
    name: "Ergo_CompanyType",
    type: "taxonomy",
    taxonomyKey: "SAGErgoCompanyType",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.companyType.label"),
      isDisabled: route === "offer",
    }),
    section: "ergo",
    position: "middle",
    isPhysicalPerson: false,
  },

  {
    name: "Gjensidige_ApplyMaxDiscount",
    type: "checkbox",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.gjensidige_ApplyMaxDiscount.label"),
      isDisabled: route === "offer",
    }),
    section: "gjensidige",
    position: "left",
  },
  {
    name: "Gjensidige_DiscountPercent",
    type: "number",
    borderless: false,
    suffix: "%",
    d: ({ route, t, values }) => ({
      label: t("sag.calculationForm.gjensidige_DiscountPercent.label"),
      isDisabled: route === "offer" || values.Gjensidige_ApplyMaxDiscount,
    }),
    section: "gjensidige",
    position: "middle",
  },
  {
    name: "Gjensidige_SpecialUsage",
    type: "checkbox",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.gjensidige_SpecialUsage.label"),
      isDisabled: route === "offer",
    }),
    section: "gjensidige",
    position: "right",
  },
  {
    name: "LietuvosDraudimas_SpecialUsage",
    type: "checkbox",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.lietuvosDraudimas_SpecialUsage.label"),
      isDisabled: route === "offer",
    }),
    section: "lietuvosDraudimas",
    position: "left",
  },
  // Policy

  {
    name: "OwnerEmail",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerEmail.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: false,
  },
  {
    name: "OwnerTelephone",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.ownerTelephone.label"),
      isDisabled: route === "offer",
    }),
    section: "owner",
    position: "left",
    isPhysicalPerson: false,
  },

  {
    name: "SelectedInsurer",
    type: "selectlist",
    isRequired: true,
    items: "offerPage.selectedInsurers",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.selectedInsurer.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "PolicyHolderEmail",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderEmail.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "PolicyHolderTelephone",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderTelephone.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "left",
    isPhysicalPerson: true,
  },
  {
    name: "PolicyHolderAdministrativeUnit",
    type: "taxonomy",
    isRequired: true,
    taxonomyKey: "SAGLDAdministrativeUnit",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderAdministrativeUnit.label"),
      isDisabled: true,
    }),
    section: "policy",
    position: "right",
  },
  {
    name: "PolicyHolderLocality",
    type: "taxonomy",
    isRequired: false,
    noTransform: true,
    taxonomyKey: "",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderLocality.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "right",
  },
  {
    name: "PolicyHolderStreet",
    type: "taxonomy",
    isRequired: false,
    noTransform: true,
    taxonomyKey: "",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderStreet.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "right",
  },
  {
    name: "PolicyHolderStreetNo",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderStreetNo.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "right",
  },
  {
    name: "PolicyHolderFlatNo",
    type: "text",
    d: ({ route, t }) => ({
      label: t("sag.calculationForm.PolicyHolderFlatNo.label"),
      isDisabled: false,
    }),
    section: "policy",
    position: "right",
  },
];

export const configObject = config.reduce((c, f) => {
  c[f.name] = f;
  return c;
}, {});
